import React, { createContext, useContext, useState, useEffect } from "react";

interface TokenContextType {
  token: string;
  setToken: (token: string) => void;
}

const TokenContext = createContext<TokenContextType>({
  token: "",
  setToken: () => {}
});

export const TokenProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [token, setToken] = useState<string>("");

  useEffect(() => {
    if (typeof window.__initialTruDocToken === "string") {
      setToken(window.__initialTruDocToken);
    }
  }, []);

  return (
    <TokenContext.Provider value={{ token, setToken }}>
      {children}
    </TokenContext.Provider>
  );
};

export const useToken = () => useContext(TokenContext);
declare global {
  interface Window {
    __initialTruDocToken?: string;
  }
}
